export function OfflineError(message?: string): void {
    this.message = message || "OfflineError";
    this.stack = (new Error()).stack;
}
OfflineError.prototype.name = "OfflineError";
OfflineError.prototype.toString = function () {
    return this.message;
};

export function OnlineNotAuthenticatedError(message?: string): void {
    this.message = message || "OnlineNotAuthenticatedError";
    this.stack = (new Error()).stack;
}
OnlineNotAuthenticatedError.prototype.name = "OnlineNotAuthenticatedError";
OnlineNotAuthenticatedError.prototype.toString = function () {
    return this.message;
};



// WEBPACK FOOTER //
// ./src/core/error/errors.ts